module.exports = __webpack_public_path__ + "static/media/visa.092a92f2.svg";